import React from 'react';
import {Stack} from '@mui/material';
import {Body} from '@lightricks/react-design-system';
import numeral from 'numeral';
import translate from '@/utils/translate';
import type {GigAffiliateData} from '../shell/informationTypes';
import {NO_VALUE} from './discountDisplay';
import styles from './AffiliateIncomePage.module.scss';

interface AffiliateStatsProps {
  affiliate: GigAffiliateData;
  updatedLabel: string | null;
}

function AffiliateStats({affiliate, updatedLabel}: AffiliateStatsProps) {
  return (
    <Stack
      component="section"
      spacing={2}
      className={styles.stats}
      data-testid="affiliate-stats"
    >
      <Stack spacing={0.5}>
        <Body size="sm" className={styles.statLabel}>
          {translate('Usage Count')}
        </Body>
        <Body size="md" data-testid="affiliate-usage-count">
          {affiliate.usageCount ?? NO_VALUE}
        </Body>
      </Stack>

      <Stack spacing={0.5}>
        <Body size="sm" className={styles.statLabel}>
          {translate('Current Affiliate Income')}
        </Body>
        <Body size="md" data-testid="affiliate-income">
          {numeral(affiliate.commissionIncomeUsd ?? 0).format('$0,0.00')}
        </Body>
      </Stack>

      {updatedLabel ? (
        <Body
          size="sm"
          className={styles.statLabel}
          data-testid="affiliate-updated"
        >
          {updatedLabel}
        </Body>
      ) : null}
    </Stack>
  );
}

export default AffiliateStats;
